enum ActionTypes {
  FETCH_SIGNING_RULES_AND_SIGNATORIES_REQUEST = 'SigningRulesAndSignatories/FETCH_SIGNING_RULES_AND_SIGNATORIES_REQUEST',
  FETCH_SIGNING_RULES_AND_SIGNATORIES_SUCCESS = 'SigningRulesAndSignatories/FETCH_SIGNING_RULES_AND_SIGNATORIES_SUCCESS',
  FETCH_SIGNING_RULES_AND_SIGNATORIES_FAILURE = 'SigningRulesAndSignatories/FETCH_SIGNING_RULES_AND_SIGNATORIES_FAILURE',
}

export default ActionTypes;
